import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export default function LiveClock({ className = "" }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const str = now.toLocaleString("en-GB", {
    weekday: "short", day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  });
  return (
    <span className={`inline-flex items-center gap-2 text-sm text-gray-300 keep-ltr ${className}`} data-testid="live-clock">
      <Clock className="w-4 h-4 text-orange-400" /> {str}
    </span>
  );
}
